import { ContextualActionsComponent, contextualActionsTemplate } from './ContextualActions';
import styles from './ContextualActions.styles.scss';
const contextualActionsDefinition = {
    baseName: 'contextual-actions',
    template: contextualActionsTemplate,
    styles,
};
export const chameleonContextualActions = ContextualActionsComponent.compose(contextualActionsDefinition);
